module.exports = __webpack_public_path__ + "static/media/Michelle Wegenstein.e5f1d8f5.png";